import React from 'react'
import FJButton from "fj-components/FJButton";
import Style from './FJUpgradeButton.module.less'
import classNames from 'classnames'

function FJUpgradeButton (props) {

  const {className} = props;
  return (
    <FJButton {...props} className={classNames(className, Style.button)} />
  );
}

export default FJUpgradeButton;
